/**
 * Configuration passed to {@link NbxDialogService.open}.
 * Modal components can inject this class to access {@link data} and dialog settings.
 *
 * Mirrors the subset of PrimeNG's `DynamicDialogConfig` that this codebase uses,
 * so migrating a component is only a one-line import change.
 */
export class NbxDialogConfig<T = unknown> {
  data?: T;

  header?: string;

  showHeader?: boolean;

  styleClass?: string;

  modal?: boolean;

  /**
   * @deprecated Backdrop click now follows {@link closable}.  Kept for
   * backward compatibility with existing call sites; the value is ignored.
   */
  dismissableMask?: boolean;

  closable?: boolean;

  contentStyle?: Record<string, string | number>;
}
